import { render, staticRenderFns } from "./MentionEditor.vue?vue&type=template&id=346d204e&scoped=true"
import script from "./MentionEditor.vue?vue&type=script&lang=js"
export * from "./MentionEditor.vue?vue&type=script&lang=js"
import style0 from "./MentionEditor.vue?vue&type=style&index=0&id=346d204e&prod&lang=scss&scoped=true"
import style1 from "./MentionEditor.vue?vue&type=style&index=1&id=346d204e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346d204e",
  null
  
)

export default component.exports